import React from 'react'
import PropTypes from 'prop-types'
import Contacts from '../../../components/Contacts'
import Carousel from '../../../components/Carousel'
import CarouselArrow from '../../../components/CarouselArrow'
import SliderCard from '../../../components/SliderCard'
import TrapezoidShape from '../../../components/TrapezoidShape'
import SectionHeading from '../../../components/Heading'
import PageLayout from '../../../components/layouts/PageLayout'
import { Link } from 'react-router-dom'
import InteractiveMap from '../../../components/ImageMapper'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import VisibilitySensor from 'react-visibility-sensor'
import { withNamespaces } from 'react-i18next'

class View extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			interactiveMapWidth: 0,
			showSchemaTooltips: false
		}
	}

	componentDidMount() {
		this.setState({
			interactiveMapWidth: window.innerWidth > 980 ? window.innerWidth-90 : window.innerWidth
		})
	}

	onFloorClick = area => {
		const { history } = this.props
		if ( area.name === 'parking') {
			history.push(`/${area.name}`)
			return;
		}

		history.push(`/apartments/${area.name}`)
	}

	getSchemaOffset () {
		if ( window.innerWidth <= 740) return 0

		return 80
	}

	onChange = isVisible => {
		this.setState({
		  showSchemaTooltips: isVisible
		})
	}

	render() {
		const { t } = this.props
		const areas = [
			{ name: "ab/1", title: `${t("general.floor")} 1`, coords: [29,1058,467,1058,467,1107,1017,1107,1017,1004,472,1002,472,953,29,950], shape: "poly" },
			{ name: "ab/2", title: `${t("general.floor")} 2`, coords: [29,852,469,854,469,906,1019,906,1017,1004,469,1002,469,953,29,950], shape: "poly" },
			{ name: "ab/3", title: `${t("general.floor")} 3`, coords: [27,745,472,745,472,790,1015,792,1015,904,467,899,467,848,27,857], shape: "poly" },
			{ name: "ab/4", title: `${t("general.floor")} 4`, coords: [194,644,523,644,523,695,1019,688,1019,794,472,791,472,747,25,745,25,702,194,689], shape: "poly" },
			{ name: "c/1", title: `${t("general.floor")} 1`, coords: [1017,1033,1551,1136], shape: "rect" },
			{ name: "c/2", title: `${t("general.floor")} 2`, coords: [1019,937,1551,1035], shape: "rect" },
			{ name: "c/3", title: `${t("general.floor")} 3`, coords: [1019,830,1551,937], shape: "rect" },
			//{ name: "c/4", title: `${t("general.floor")} 4`, coords: [1551,830,1017,713], shape: "rect" },
			{ name: "d/1", title: `${t("general.floor")} 1`, coords: [1551,1058,2099,1163], shape: "rect" },
			{ name: "d/2", title: `${t("general.floor")} 2`, coords: [1551,959,2096,1055], shape: "rect" },
			{ name: "d/3", title: `${t("general.floor")} 3`, coords: [1551,856,2101,959], shape: "rect" },
			//{ name: "d/4", title: `${t("general.floor")} 4`, coords: [1551,733,2052,736,2052,762,2327,765,2327,818,2394,818,2479,832,2476,885,2123,883,2090,856,1551,856], shape: "poly" },
			{ name: "cd/4", title: `${t("general.floor")} 4`, coords: [1022,711,1024,818,1559,818,1559,841,2086,838,2086,751,1556,747,1550,711], shape: "poly" },
			{ name: "e/1", title: `${t("general.floor")} 1`, coords: [2110,1080,2514,1181], shape: "rect" },
			{ name: "e/2", title: `${t("general.floor")} 2`, coords: [2108,979,2514,1080], shape: "rect" },
			{ name: "e/3", title: `${t("general.floor")} 3`, coords: [2110,883,2514,982], shape: "rect" },
			{ name: "e/4", title: `${t("general.floor")} 4`, coords: [2095,774,2095,859,2126,872,2479,872,2479,830,2343,827,2336,776], shape: "poly" },
			{ name: "parking", title: `${t("general.parkingLots")}`, coords: [2300,1181,2528,1302], shape: "rect" }
		]
		return <PageLayout isHome>
			<div className='c-content'>
				<div className='c-hero u-relative' data-sidetitle={t("general.siteName")} >
					<TrapezoidShape className='u-show-on-desktop' position='right' size='small' direction='bottom' theme='light' />
					<Carousel
						className='c-hero__slider'
						options={{
							dots: true,
							infinite: true,
							autoplay: true,
							arrows: true,
							speed: 4000,
							slidesToShow: 1,
							nextArrow: <CarouselArrow className='slick-arrow slick-next u-cursor-pointer' >{t("general.nextBtn")} &#8594;</CarouselArrow>,
							prevArrow: <CarouselArrow className='slick-arrow slick-prev u-cursor-pointer' >&#8592; {t("general.previousBtn")}</CarouselArrow>,
							responsive: [
								{
									breakpoint: 980,
									settings: {
										dots: false,
										arrows: false
									}
								},
								{
									breakpoint: 580,
									settings: {
										dots: false,
										arrows: false
									}
								}
							]
						}}
					>
						<img src='/img/hero-img-1.png' alt='sdddv' />
						<img src='/img/hero-img-2.png' alt='sdddv' />
						<img src='/img/hero-img-3.png' alt='sdddv' />
					</Carousel>
					<div className='c-hero__overlay u-padding-horizontal u-padding-horizontal-huge@desktop'>
						<SectionHeading priority={1} classes='c-hero__title u-center-on-mobile u-text--white u-weight--normal u-margin-bottom@desktop u-margin-bottom-tiny' text={t("general.siteName")} />
						<p className='c-hero__descr u-center-on-mobile u-text--white u-weight--normal u-margin-bottom-huge@desktop u-margin-bottom-tiny'>{t("home.heroSliderText")}</p>
						<AnchorLink offset={this.getSchemaOffset} className='c-btn c-btn--albes' href='#entrances'>{t("home.heroSliderBtn")} &#8595;</AnchorLink>
					</div>
				</div>
				<div className='o-wrapper'>
					<div className='o-layout o-layout--middle u-padding-vertical u-padding-vertical-huge@desktop u-center-on-mobile'>
						<div className='o-layout__item u-1/1 u-1/2@tablet'>
							<div className='u-text--finch u-text--giant u-weight--normal'>{t("home.introLeft")}</div>
						</div>
						<div className='o-layout__item u-1/1 u-1/2@tablet'>
							<SectionHeading classes='u-center-on-mobile u-text--black u-weight--bold u-text--large u-margin-bottom@desktop u-margin-bottom-tiny' text={t("general.siteName")} />
							<p className='u-text--large'>{t("home.introRight")}</p>
							<Link to='/about' className='c-btn c-btn--bordered c-btn--bordered--finch u-text--normal'>{t("home.introBtn")} &#8594;</Link>
						</div>
					</div>
				</div>
				<VisibilitySensor
					scrollCheck
					scrollThrottle={100}
					intervalDelay={8000}
					onChange={this.onChange}
					partialVisibility={true}
					offset={{
						top:200,
						bottom: 200
					}}
					>
				<div className='u-relative' id='entrances'>
					<div className='c-schema c-schema--bordered'>
						<div className='c-interactive-map__holder u-relative'>
							<div className={`c-tooltip c-tooltip--small c-tooltip--ab u-bg--black u-text--normal u-weight--bold u-text--albes${this.state.showSchemaTooltips ? ' fadeIn' : ''}`}>A-B</div>
							<div className={`c-tooltip c-tooltip--small c-tooltip--c u-bg--black u-text--normal u-weight--bold u-text--albes${this.state.showSchemaTooltips ? ' fadeIn' : ''}`}>C</div>
							<div className={`c-tooltip c-tooltip--small c-tooltip--d u-bg--black u-text--normal u-weight--bold u-text--albes${this.state.showSchemaTooltips ? ' fadeIn' : ''}`}>D</div>
							<div className={`c-tooltip c-tooltip--small c-tooltip--e u-bg--black u-text--normal u-weight--bold u-text--albes${this.state.showSchemaTooltips ? ' fadeIn' : ''}`}>E</div>
							<InteractiveMap
								url='/img/building-schema.png'
								name='planABparking'
								areas={areas}
								width={this.state.interactiveMapWidth}
								imgWidth={2530}
								fillColor='rgba(247,233,210,0.7)'
								mapType='homeschema'
								onClickHandler={path => this.onFloorClick(path)}
								/>
						</div>
					</div>
					<TrapezoidShape className='u-show-on-desktop' position='left' size='large' direction='bottom' theme='light'>
						<Link to='/apartments' className='c-btn c-btn--bordered c-btn--bordered--finch u-padding-vertical-tiny'>{t("home.chooseApartments")} &#8594;</Link>
					</TrapezoidShape>
				</div>
				</VisibilitySensor>
				<div className='u-relative'>
					<TrapezoidShape className='u-show-on-desktop' position='right' size='large' direction='top' theme='dark'>
						<Link to={'/parking'} className='c-btn c-btn--bordered c-btn--bordered--albes u-padding-vertical-tiny'>{t("home.viewParking")} &#8594;</Link>
					</TrapezoidShape>
					<div className='o-wrapper'>
						<div className='o-layout o-layout--middle u-padding-vertical u-padding-vertical-huge@desktop'>
							<div className='o-layout__item u-text--center u-border-bottom--bud@desktop u-border-bottom--bud@tablet u-border-right--bud@desktop u-border-right--bud@tablet u-padding-vertical u-padding-vertical-large@desktop u-padding-horizontal@desktop u-1/1 u-1/2@tablet u-1/3@desktop'>
								<div className='c-icon c-icon--marker c-icon--border u-margin-bottom' />
								<SectionHeading priority={3} classes='u-text--black u-text--large u-margin-bottom-small u-weight--normal' text={t("home.box1Title")} />
								<p className='u-margin-none'>{t("home.box1Text")}</p>
							</div>
							<div className='o-layout__item u-text--center u-border-bottom--bud@desktop u-border-bottom--bud@tablet u-border-right--bud@desktop u-padding-vertical u-padding-vertical-large@desktop u-padding-horizontal@desktop u-1/1 u-1/2@tablet u-1/3@desktop'>
								<div className='c-icon c-icon--communication c-icon--border u-margin-bottom' />
								<SectionHeading priority={3} classes='u-text--black u-text--large u-margin-bottom-small u-weight--normal' text={t("home.box2Title")} />
								<p className='u-margin-none'>{t("home.box2Text")}</p>
							</div>
							<div className='o-layout__item u-text--center u-border-bottom--bud@desktop u-border-bottom--bud@tablet u-border-right--bud@tablet u-padding-vertical u-padding-vertical-large@desktop u-padding-horizontal@desktop u-1/1 u-1/2@tablet u-1/3@desktop'>
								<div className='c-icon c-icon--design c-icon--border u-margin-bottom' />
								<SectionHeading priority={3} classes='u-text--black u-text--large u-margin-bottom-small u-weight--normal' text={t("home.box3Title")} />
								<p className='u-margin-none'>{t("home.box3Text")}</p>
							</div>
							<div className='o-layout__item u-text--center u-border-right--bud@desktop u-border-bottom--bud@tablet u-padding-vertical u-padding-vertical-large@desktop u-padding-horizontal@desktop u-1/1 u-1/2@tablet u-1/3@desktop'>
								<div className='c-icon c-icon--heart c-icon--border u-margin-bottom' />
								<SectionHeading priority={3} classes='u-text--black u-text--large u-margin-bottom-small u-weight--normal' text={t("home.box4Title")} />
								<p className='u-margin-none'>{t("home.box4Text")}</p>
							</div>
							<div className='o-layout__item u-text--center u-border-right--bud@desktop u-border-right--bud@tablet u-padding-vertical u-padding-vertical-large@desktop u-padding-horizontal@desktop u-1/1 u-1/2@tablet u-1/3@desktop'>
								<div className='c-icon c-icon--drawing c-icon--border u-margin-bottom' />
								<SectionHeading priority={3} classes='u-text--black u-text--large u-margin-bottom-small u-weight--normal' text={t("home.box5Title")} />
								<p className='u-margin-none'>{t("home.box5Text")}</p>
							</div>
							<div className='o-layout__item u-text--center u-padding-vertical u-padding-vertical-large@desktop u-padding-horizontal@desktop u-1/1 u-1/2@tablet u-1/3@desktop'>
								<div className='c-icon c-icon--building c-icon--border u-margin-bottom' />
								<SectionHeading priority={3} classes='u-text--black u-text--large u-margin-bottom-small u-weight--normal' text={t("home.box6Title")} />
								<p className='u-margin-none'>{t("home.box6Text")}</p>
							</div>
						</div>
					</div>
				</div>
				<div className='o-wrapper'>
					<Carousel
						className='c-cards-slider'
						options={{
							slidesToShow: 2,
							responsive: [
								{
									breakpoint: 980,
									settings: {
										slidesToShow: 1,
										infinite: true,
										autoplay: true
									}
								}
							]
						}} >
						<SliderCard
							title={t('home.quickLink1Title')}
							descr={t('home.quickLink1Text')}
							linkTo='/materials'
							imgLink='/img/slide1.png'
						/>
						<SliderCard
							title={t('home.quickLink2Title')}
							descr={t('home.quickLink2Text')}
							linkTo='/about'
							imgLink='/img/slide2.png'
						/>
						<SliderCard
							title={t('home.quickLink3Title')}
							descr={t('home.quickLink3Text')}
							linkTo='/apartments'
							imgLink='/img/slide3.png'
						/>
					</Carousel>
				</div>
				<div className='o-wrapper'>
					<div className='o-layout o-layout--middle u-padding-vertical u-padding-top-large@desktop u-padding-bottom-small@desktop u-center-on-mobile'>
						<div className='o-layout__item u-1/1 u-1/2@tablet'>
							<SectionHeading classes='u-text--finch u-text--giant u-weight--normal' text={t('home.whyJura')} />
						</div>
						<div className='o-layout__item u-1/1 u-1/2@tablet'>
							<div className='o-block'>
								<Link to='/apartments' className='c-btn c-btn--finch'>{t('home.availableApartments')} &#8594;</Link>
							</div>
						</div>
					</div>
					<div className='o-layout u-padding-vertical-small u-padding-bottom-large@desktop u-center-on-mobile'>
						<div className='o-layout__item u-1/1 u-1/3@tablet'>
							<h3 className='u-text--large u-text--black'>{t('home.whyJura1Title')}</h3>
							<p>{t('home.whyJura1Text')}</p>
						</div>
						<div className='o-layout__item u-1/1 u-1/3@tablet'>
							<h3 className='u-text--large u-text--black'>{t('home.whyJura2Title')}</h3>
							<p>{t('home.whyJura2Text')}</p>
						</div>
						<div className='o-layout__item u-1/1 u-1/3@tablet'>
							<h3 className='u-text--large u-text--black'>{t('home.whyJura3Title')}</h3>
							<p>{t('home.whyJura3Text')}</p>
						</div>
						<div className='o-layout__item u-1/1'>
							<Link to='/why-jura' className='c-btn c-btn--bordered c-btn--bordered--finch'>{t('general.viewMore')} &#8594;</Link>
						</div>
					</div>
				</div>
			</div>
			<Contacts />
		</PageLayout>
	}
}

View.propTypes = {
	currencies: PropTypes.number
}

export default withNamespaces()(View)



// WEBPACK FOOTER //
// ./src/routes/Home/components/View.js